<template>
  <div class="page-channel page-content" v-loading="body_loading">
    <div class="main-body">
      <el-row class="hd">
        <el-col :span="12">
          <h3 style="float: none;">商品管理</h3>
          <div class="flex-block breadcrumb-box">
            <div class="position-text">位置：</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item>库存管理</el-breadcrumb-item>
              <el-breadcrumb-item>商品管理</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
        <el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
          <el-button type="primary" class="btn-bg-p" @click="handleChannel('add')">添加 <i class="el-icon-plus"></i></el-button>
          <el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量删除</el-button>
        </el-col>
      </el-row>
      <div class="bd">
        <div class="search-block content-body">
          <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
            <el-form-item prop="stock_number" label="商品编码：" style="margin-bottom: 0;">
              <el-input v-model="form_search.stock_number" size="small" placeholder="商品编码" clearable></el-input>
            </el-form-item>
            <el-form-item prop="name" label="商品名称：" style="margin-bottom: 0;">
              <el-input v-model="form_search.name" size="small" placeholder="商品名称" clearable></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom: 0;">
              <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-block content-body">
          <div ref="contentBody">
            <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="id" width="55" label="ID" align="center"></el-table-column>
              <el-table-column prop="stock_number" align="center" label="商品编码" min-width="120">
              </el-table-column>
              <el-table-column prop="name" align="center" label="商品名称" min-width="120">
              </el-table-column>
              <el-table-column prop="unit" align="center" label="商品单位" min-width="120">
              </el-table-column>
              <el-table-column prop="m_time" align="center" label="更新时间" min-width="180">
              </el-table-column>
              <el-table-column prop="c_time" align="center" label="创建时间" min-width="180">
              </el-table-column>
              <el-table-column prop="operating" align="center" label="操作" min-width="200" fixed="right">
                <template slot-scope="scope">
                  <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleChannel('edit',scope.row)">编辑</el-button>
                  <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteChannel(scope.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="table_data.page_info.page"
              :page-sizes="[10,30, 50,80,100]"
              :page-size="table_data.page_info.pageSize"
              layout="total, sizes, prev, pager, next"
              :total="table_data.page_info.total">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog class="dialog-export channel-dialog" :title="dlg_group.title" :visible.sync="dlg_group.visible" width="534px" @closed="closeChannel" :close-on-click-modal="false">
      <el-form ref="formChannel" :model="dlg_group.form" label-width="110px" :rules="dlg_group.rules" @submit.native.prevent>
        <el-form-item prop="name" style="margin-top: 15px;" label="商品名称：" :error="dlg_group.error.name">
          <el-input size="small" v-model="dlg_group.form.name" placeholder='请输入商品名称' clearable></el-input>
        </el-form-item>
        <el-form-item prop="unit" style="margin-top: 15px;" label="商品单位：" :error="dlg_group.error.unit">
          <el-input size="small" v-model="dlg_group.form.unit" placeholder='请输入商品单位' clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
                <el-button @click="dlg_group.visible = false">取 消</el-button>
                <el-button type="primary" @click="submitChannel()" :loading="dlg_group.btn_loading">确认</el-button>
            </span>
    </el-dialog>
    <el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
      <img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'usercenter',
  data() {
    return {
      clientHeight:'',
      body_loading:false,
      is_refresh: true,
      baseUrl:this.$client.IMG_URL,
      //搜索
      form_search:{
        stock_number:"",
        name:"",
      },
      init_data: {

      },
      multipleSelection: [],
      table_data:{
        loading: false,
        list:[],
        page_info: {
          page: 1,
          pageSize: 30,
          total: 130
        }
      },
      dlg_group:{
        id:'',
        visible:false,
        btn_loading:false,
        api: '',
        title:'',
        hide_upload: false,
        img_list: [],
        form:{
          name:'',
          unit:'',
        },
        error:{
          name:''
        },
        reset_form: {},
        init_data:{

        },
        rules:{
          name:{required: true, message: '请输入商品名称', trigger: ['change','blur']},
          unit:{required: true, message: '请输入商品单位', trigger: ['change','blur']},
        },
        params:{
          action: this.$client.API_URL+'/adminapi/upload/images',
          data:{path:'banner'},
          headers:{token:localStorage.getItem('token')}
        }
      },
      dlg_preview:{
        visible: false,
        img_url: ''
      }
    }
  },
  created() {
    document.title = '商品管理';
    this.dlg_group.reset_form = Object.assign({}, this.dlg_group.form);
    this.getList();
  },
  methods: {
    searchList(){
      var _this = this;
      _this.table_data.page_info.page = 1;
      _this.getList();
    },
    getList() {
      var _this = this;
      var params = _this.form_search;
      params.p = _this.table_data.page_info.page;
      params.pageSize = _this.table_data.page_info.pageSize;
      _this.table_data.loading = true;
      var status_list = [{id:-1, name: '全部'}];
      this.$client.get('/adminapi/stockproduct/list', params, function(res,message){
        _this.table_data.list = res.list;
        _this.table_data.page_info = res.pager;
        _this.table_data.loading = false;
      },function(res){
        _this.table_data.loading = false;
      });
    },
    handleSizeChange(val) {
      this.table_data.page_info.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.table_data.page_info.page = val;
      this.getList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    uploadSuccessImg(res, file, fileList){
      this.dlg_group.img_list = fileList;
      this.dlg_group.form.image_url = res.data.file_url;
      this.dlg_group.hide_upload = true;
    },
    removeImg(file, fileList){
      this.dlg_group.form.image_url = '';
      this.dlg_group.img_list = [];
      this.dlg_group.hide_upload = false;
    },
    delmultiple(){
      var _this = this;
      var mullist = this.multipleSelection;
      if(mullist.length == 0){
        _this.$message("请勾选需要删除的商品");
        return;
      }
      var idList = [];
      for(var i=0;i<mullist.length;i++){
        idList.push(mullist[i].id);
      }
      var params = {id:idList.join(",")}
      this.$confirm('确定要批量删除？', "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass:"icon-delete el-icon-delete",
        customClass:"my-confirm-box",
        center: true,
      })
      .then(() => {
        _this.$client.post('/adminapi/stockproduct/delete', params, function(res,message){
          _this.getList();
        },function(res){

        });
      })
      .catch(() => {});
    },

    handleChannel(type,data){
      this.dlg_group.visible = true;
      if(type == 'add'){
        this.dlg_group.title = '添加商品';
        this.dlg_group.api = '/adminapi/stockproduct/save';
      }else{
        this.dlg_group.id= data.id;
        this.dlg_group.title = '编辑商品';
        if(data){
          for(var key in this.dlg_group.form){
            this.dlg_group.form[key] = data[key];
          }
        }
        this.dlg_group.api = '/adminapi/stockproduct/save?id=' + data.id;
      }
    },
    deleteChannel(id){
      var _this = this;
      this.$confirm('确定要删除？', "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass:"icon-delete el-icon-delete",
        customClass:"my-confirm-box",
        center: true,
      })
      .then(() => {
        _this.$client.post('/adminapi/stockproduct/delete', {id:id}, function(res,message){
          _this.getList();
        },function(res){

        });
      })
      .catch(() => {});
    },
    submitChannel(){
      var _this = this;
      _this.$refs['formChannel'].validate((valid) => {
        if (valid) {
          this.dlg_group.btn_loading = true;
          this.$client.post(this.dlg_group.api, this.dlg_group.form, function(res,message){
            _this.$message(message);
            _this.getList();
            _this.dlg_group.btn_loading = false;
            _this.dlg_group.visible = false;
          }, function(message){
            _this.dlg_group.btn_loading = false;
            if((typeof message)==='object'){
              for(var key in message){
                _this.dlg_group.error[key] = message[key];
              }
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    closeChannel(){
      for(var key in this.dlg_group.form){
        this.dlg_group.form[key] = this.dlg_group.reset_form[key];
      }
      this.$nextTick(()=>{
        this.$refs.formChannel.clearValidate();
      })
    },
    changeFixed(clientHeight){
      this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
    }
  },
  mounted(){
    // 获取浏览器可视区域高度
    this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
    //console.log(self.clientHeight);
    window.onresize = function temp() {
      this.clientHeight = `${document.documentElement.clientHeight}`;
    };
  },
  watch: {
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: function () {
      this.changeFixed(this.clientHeight)
    }
  }
}
</script>
<style>

</style>
<style scoped>

</style>